import styled from 'styled-components'

export const NotFoundContainer = styled.div`
  width: 100%;
  height: 98%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;

  > h2 {
    max-width: 300px;
    line-height: 1.3;
    font-weight: 400;
  }
`
